// Components
import { BaseUploaderInline } from 'components'

// Interfaces
import { IBaseUploaderInlineMultipleProps } from './interfaces'

// i18n
import { useTranslation } from 'react-i18next'

// Antd
import { Button, Popconfirm } from 'antd'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'

// Mobx
import { observer } from 'mobx-react'

const BaseUploaderInlineMultiple = observer(
  ({ files, onDelete, onUpload, onDownload, onAddItem, onDeleteItem, isReadOnly }: IBaseUploaderInlineMultipleProps) => {
    // Hook
    const { t } = useTranslation()

    return (
      <>
        {files.map((file, index) => (
          <div key={file.id} className="mb-4">
            <BaseUploaderInline
              originalFileName={file.userOriginalFileName}
              onUpload={_file =>
                onUpload && onUpload({ fileId: file.id!, transactionFileId: file.userFileTransactionId! }, _file)
              }
              onDelete={() => onDelete && onDelete({ fileId: file.id!, userFileTransactionId: file.userFileTransactionId! })}
              onDownload={() => onDownload && onDownload({ fileId: file.id!, blobId: file.userFileBlobId! })}
              loading={file.loading?.isActionLoading || file.loading?.isDownloadLoading}
              isReadOnly={isReadOnly}
            >
              {/* Delete File Item */}
              {!isReadOnly && index > 0 && !file.loading?.isActionLoading && !file.loading?.isDownloadLoading && (
                <div className="flex items-center">
                  <Popconfirm
                    title={`${t('app.action.delete')}?`}
                    onConfirm={() =>
                      onDeleteItem &&
                      onDeleteItem({ userFileTransactionId: file.userFileTransactionId || null, fileId: file.id! })
                    }
                  >
                    <MinusCircleOutlined />
                  </Popconfirm>
                </div>
              )}
            </BaseUploaderInline>
          </div>
        ))}

        {/* Add Button */}
        {!isReadOnly && files.length < 5 && (
          <div className="flex items-center justify-center mt-2 text-center">
            <Button className="custom-button common" type="link" onClick={onAddItem}>
              <div className="flex items-center gap-1">
                <PlusOutlined />
                {t('app.addFile')}
              </div>
            </Button>
          </div>
        )}
      </>
    )
  },
)

export { BaseUploaderInlineMultiple }
